import { render, staticRenderFns } from "./Doctor.vue?vue&type=template&id=8eae4d5e&scoped=true"
import script from "./Doctor.vue?vue&type=script&lang=ts"
export * from "./Doctor.vue?vue&type=script&lang=ts"
import style0 from "./Doctor.vue?vue&type=style&index=0&id=8eae4d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eae4d5e",
  null
  
)

export default component.exports